import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  className: PropTypes.string,
  status: PropTypes.string /* inactive, pending, success, error */
  , percent: PropTypes.number.isRequired,
  autoIncrement: PropTypes.bool,
  intervalTime: PropTypes.number,
  multiplier: PropTypes.number
};

var defaultProps = {
  className: '',
  percent: -1,
  autoIncrement: true,
  intervalTime: 600,
  multiplier: 4
};

var ProgressBar = function (_PureComponent) {
  _inherits(ProgressBar, _PureComponent);

  function ProgressBar(props) {
    _classCallCheck(this, ProgressBar);

    var _this = _possibleConstructorReturn(this, (ProgressBar.__proto__ || Object.getPrototypeOf(ProgressBar)).call(this, props));

    _this.componentDidMount = function () {
      _this.handleProps(_this.props);
    };

    _this.componentWillReceiveProps = function (nextProps) {
      _this.handleProps(nextProps);
    };

    _this.componentWillUnmount = function () {
      clearTimeout(_this.timeout);
      clearTimeout(_this.timeout2);
    };

    _this.setPercent = function (value) {
      var _this$props = _this.props,
          multiplier = _this$props.multiplier,
          intervalTime = _this$props.intervalTime,
          autoIncrement = _this$props.autoIncrement;

      _this.setState({
        percent: value
      });
      if (!autoIncrement || value === -1 || value === 99 || value > 100) {
        return;
      }
      /* success or error */
      if (value === 100) {
        _this.timeout = setTimeout(function () {
          _this.setPercent(101);
          _this.timeout2 = setTimeout(function () {
            return _this.setPercent(-1);
          }, 400);
        }, 600);

        return;
      }
      var nextPercent = value;
      nextPercent += Math.random() + multiplier - Math.random();
      nextPercent = nextPercent < 99 ? nextPercent : 99;

      _this.timeout = setTimeout(function () {
        return _this.setPercent(nextPercent);
      }, intervalTime);
    };

    _this.handleProps = function (nextProps) {
      if (_this.props.status === nextProps.status) {
        return;
      }
      clearTimeout(_this.timeout);
      clearTimeout(_this.timeout2);
      if (nextProps.status === 'pending') {
        _this.setPercent(0);
      }
      if (nextProps.status === 'success' || nextProps.status === 'error') {
        _this.setPercent(100);
      }
      if (nextProps.status === 'inactive') {
        _this.setPercent(-1);
      }
    };

    _this.state = {
      percent: props.percent
    };
    return _this;
  }

  _createClass(ProgressBar, [{
    key: 'render',
    value: function render() {
      var className = this.props.className;
      var percent = this.state.percent;


      if (className) {
        className += ' ';
      }
      className += 'progress-bar';
      if (percent < 0 || percent > 100) {
        className += ' progress-bar-hide';
      }
      var style = { width: (percent < 0 ? 0 : percent) + '%' };
      var percentClassName = 'progress-bar-percent';
      if (this.props.status === 'success') {
        percentClassName += ' success';
      } else if (this.props.status === 'error') {
        percentClassName += ' error';
      }
      return React.createElement(
        'div',
        { className: className },
        React.createElement('div', { className: percentClassName, style: style })
      );
    }
  }]);

  return ProgressBar;
}(PureComponent);

ProgressBar.defaultProps = defaultProps;
ProgressBar.propTypes = propTypes;

export default ProgressBar;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/ProgressBar/index.js
// module id = 1068
// module chunks = 0